<!-- component for listing appointment requests -->
<template>
  <div class="flex-auto flex flex-column h100">
    <div class="flex-none flex items-center justify-between p2">
      <div class="caps h6 gray-3 semibold">Odottaa käsittelyä</div>
      <div class="flex-none">
        <svg class="block" width="16" height="21" viewBox="0 0 16 21" xmlns="http://www.w3.org/2000/svg">
          <g stroke="#A3ADB3" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
            <path d="M13.056 5.4c0 2.872-2.265 5.2-5.056 5.2-2.794 0-5.056-2.328-5.056-5.2v-4h10.112v4zM13.056 15.8c0-2.871-2.265-5.2-5.056-5.2-2.794 0-5.056 2.329-5.056 5.2v4h10.112v-4zM1.389 1.4H14.61M1.389 19.8H14.61"/>
            <path d="M2.944 16.6h2.723L8 14.2l2.333 2.4h2.723M4.03 8.6h7.94"/>
          </g>
      </svg>
      </div>
    </div>

    <div class="border-bottom border-gray-5 flex-auto overflow-y">
      <ul class="list-reset m0">
        <ListItem v-for="chat in chats" :chat="chat" :key="chat.id" :createLinkTo="createLinkTo" />
      </ul>
      <div class="flex items-center p2 border-top border-gray-5"></div>
    </div>
  </div>
</template>

<script>

import ListItem from '@/components/reception/ListItem.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'OwnList',
  components: { ListItem },
  props: {
    createLinkTo: Function,
  },
  computed: {
    ...mapGetters({
      chats: 'appointmentChats',
    }),
  },
};
</script>

<style scoped>
</style>
